/**
 * @author Hiroki Moto
 */

import React, { useState } from 'react';
import loadable from '@loadable/component';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import Avatar from '@components/@core/Avatar';
import DatePicker from '@components/@core/DatePicker';
import Rating from '@components/@core/Rating';
import VendorActions from '~/actions/vendor';

const Select = loadable(() => import('react-select'), { ssr: false });
const moment = extendMoment(originalMoment);

const SingleValue = (props) => (
    <div {...props}>
        <div className="d-h-start">
            <Avatar size="extraTiny" url={props?.data?.logo} />
            <p className="dsl-16 ms-2 mb-0">{props?.data.name}</p>
        </div>
    </div>
);

const Competition = ({ company, date, onDateChange }) => {
    const dispatch = useDispatch();

    const [products, setProducts] = useState(null);
    const [product, setProduct] = useState(null);
    const [competitor1, setCompetitor1] = useState(null);
    const [competitor2, setCompetitor2] = useState(null);
    const [categoryId, setCategoryId] = useState(0);

    const getProducts = (search = '', categoryId = 0) => {
        dispatch(
            VendorActions.getcategoryproductsRequest({
                categoryId,
                payload: { search },
                callback: (item) => setProducts(item?.data),
            })
        );
    };

    const handleSearch = (e) => {
        if (e !== '') getProducts(e, categoryId);
    };

    const handleProduct = (e) => {
        setProduct(e);
        setCategoryId(e?.category?.id || 0);
        setCompetitor1(null);
        setCompetitor2(null);
        getProducts('', e?.category?.id || 0);
    };

    let options = [];
    products?.map((item) => {
        const value = item.name;
        const label = item.name;
        options.push({ value, label, ...item });
    });

    const companyProduct = company?.products?.map((item) => ({
        logo: company.avatar,
        value: item.name,
        label: item.name,
        ...item,
    }));

    return (
        <div className="card mt-3">
            <p className="dsl-b20 bold">Competition</p>
            <div className="d-h-end">
                <DatePicker calendar="range" append="caret" format="MMM D, YY" as="span" align="right" value={date} mountEvent closeAfterSelect onSelect={onDateChange} />
            </div>
            <div className="d-flex ssm-column py-3">
                <div className="d-flex-1" />
                <div className="d-flex-1">
                    <p className="dsl-m12 mb-2">Select product</p>
                    <div className="d-h-start">
                        <Select
                            classNamePrefix="react-select"
                            className="product-select-list dsl-b12"
                            isSearchable
                            options={companyProduct}
                            value={product}
                            components={{ SingleValue }}
                            onChange={handleProduct}
                        />
                    </div>
                </div>
                <div className="d-flex-1">
                    <p className="dsl-m12 mb-2">Select competitor</p>
                    <div className="d-h-start">
                        <Select
                            classNamePrefix="react-select"
                            className="product-select-list dsl-b12"
                            isSearchable
                            options={options}
                            value={competitor1}
                            components={{ SingleValue }}
                            onChange={(e) => setCompetitor1(e)}
                            onInputChange={handleSearch}
                        />
                    </div>
                </div>
                <div className="d-flex-1">
                    <p className="dsl-m12 mb-2">Select competitor</p>
                    <div className="d-h-start">
                        <Select
                            classNamePrefix="react-select"
                            className="product-select-list dsl-b12"
                            isSearchable
                            options={options}
                            value={competitor2}
                            components={{ SingleValue }}
                            onChange={(e) => setCompetitor2(e)}
                            onInputChange={handleSearch}
                        />
                    </div>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1 mb-0 ssm-b-3">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">Reviews</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">{product?.stats?.rating_count || 0}</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">{competitor1?.stats?.rating_count || 0}</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">{competitor2?.stats?.rating_count || 0}</p>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">New Reviews</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">Avg Rating</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <Rating score={product?.stats?.rating_avg || 0} />
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <Rating score={competitor1?.stats?.rating_avg || 0} />
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <Rating score={competitor2?.stats?.rating_avg || 0} />
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">Recommended %</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">{product?.stats?.rating_recommended_avg || 0}%</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">{competitor1?.stats?.rolling_rating_recommended_avg || 0}%</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">{competitor2?.stats?.rolling_rating_recommended_avg || 0}%</p>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">NPS</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">{product?.stats?.nps || 0}</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">{competitor1?.stats?.popularity_score || 0}</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">{competitor2?.stats?.popularity_score || 0}</p>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">Exposure</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">Category Shares</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">Impressisons</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">{product?.stats?.impressions || 0}</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">{competitor1?.stats?.impressions || 0}</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">{competitor2?.stats?.impressions || 0}</p>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">PDF View</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">Avg Page Time</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b14 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
            </div>
            <div className="d-flex ssm-column border-top py-4">
                <div className="d-flex-1">
                    <p className="dsl-b16 bold mb-0 ssm-b-3">TTL Page Time</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b12 w-40">Select Product</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b12 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
                <div className="d-flex d-flex-1">
                    <label className="mobile-screen dsl-b12 w-40">Select Competitor</label>
                    <p className="dsl-b16 mb-0">Na</p>
                </div>
            </div>
        </div>
    );
};

Competition.propTypes = {
    company: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        products: PropTypes.array,
        stats: PropTypes.shape({
            product_count: PropTypes.number,
            popularity_score: PropTypes.number,
            rating_recommended_avg: PropTypes.number,
            rating_count: PropTypes.number,
            rating_dealership_count: PropTypes.number,
        }),
    }),
    date: PropTypes.any,
    onDateChange: PropTypes.func,
};

Competition.defaultProps = {
    company: {
        id: 0,
        name: '',
        products: [],
        stats: {
            product_count: 0,
            popularity_score: 0,
            rating_recommended_avg: 0,
            rating_count: 0,
            rating_dealership_count: 0,
        },
    },
    date: moment.range(moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')),
    onDateChange: () => {},
};

export default Competition;
